import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from './lib/ErrorBoundary';

const AppContent = React.lazy(() => import('./AppContent'));

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Suspense fallback={
          <div className="min-h-screen bg-black flex items-center justify-center">
            <div className="text-primary">Loading...</div>
          </div>
        }>
          <AppContent />
        </Suspense>
      </Router>
    </ErrorBoundary>
  );
}

export default App;